import { Controller } from "@hotwired/stimulus"

// Cmd+K / Ctrl+K opens the collapsed nav search (icon row) from anywhere on
// the page -- Tailwind UI docs search / GitHub / Linear style. Deliberately
// does not duplicate the "modal" controller's open/close/backdrop/escape/
// auto-focus logic (registered alongside this one on the same element,
// app/views/application/navs/_global_search.html.erb, which opens a native
// <dialog> via showModal() -- centering, the backdrop, Escape-to-close, and
// focusing the input are all free browser behaviour, no JS needed here) --
// this controller only decides *whether* a keypress should open it, then
// clicks the same button a real click would.
export default class extends Controller {
  static targets = ["button", "dialog"]

  trigger(event) {
    if (!this.isShortcut(event)) return
    if (this.typingElsewhere(event.target)) return
    if (!this.hasButtonTarget || this.buttonTarget.offsetParent === null) return
    // showModal() throws InvalidStateError if the dialog is already open --
    // leave it open (and focused) rather than clicking through to an error.
    if (this.hasDialogTarget && this.dialogTarget.open) return

    event.preventDefault()
    this.buttonTarget.click()
  }

  isShortcut(event) {
    return (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k"
  }

  // Standard command-palette guard: this header renders on every page, many
  // with their own forms, so don't hijack Cmd/Ctrl+K while the user is
  // typing somewhere else on the page.
  typingElsewhere(target) {
    if (!target) return false
    if (target.isContentEditable) return true
    return ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)
  }
}
